import { Button, Flex, Typography } from "antd"

export const FiatBalanceTopUpStepUi = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        If you choose to top up your balance with fiat currency, a window will
        appear with the payment details for the transfer.
      </Typography.Text>
      <div>
        <span style={{ opacity: 1 }}>🔹 </span>{" "}
        <Typography.Text>
          Important: We only accept payments from corporate bank accounts and
          businesses that have completed our KYB (Know Your Business)
          verification. If the payment details are missing or the required fiat
          currency is unavailable, please contact your Key Account Manager for
          assistance.
        </Typography.Text>
      </div>
    </Flex>
  )
}
